module.exports = __webpack_public_path__ + "assets/img/one-bg.25d10894.png";